var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#656565",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44332 9.34853C10.0317 9.4012 14.8361 4.50988 14.8361 4.50988L16.4361 5.78288C16.642 5.94666 16.9439 5.78506 16.9218 5.52293L16.4963 0.473771C16.4713 0.176695 16.1935 -0.0326006 15.9011 0.0252668L10.8278 1.02909C10.5564 1.08279 10.4962 1.44405 10.7355 1.58288L12.5199 2.61795C10.6878 5.5037 6.59259 7.32649 1.39055 8.97934C1.17762 9.047 1.2199 9.34716 1.44332 9.34853Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 9.00003C12.5 8.1716 13.1716 7.50003 14 7.50003H16C16.8284 7.50003 17.5 8.1716 17.5 9.00003V17.5H12.5V9.00003ZM14 16H16V9.00003H14V16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.5C7.17157 10.5 6.5 11.1716 6.5 12V17.5H11.5V12C11.5 11.1716 10.8284 10.5 10 10.5H8ZM10 16H8V12H10V16Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12.5C1.17157 12.5 0.5 13.1716 0.5 14V17.5H5.5V14C5.5 13.1716 4.82843 12.5 4 12.5H2ZM2 16V14H4V16H2Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChart);
export default __webpack_public_path__ + "static/media/line-chart.1b14d3438a46aca91175b9bf08703020.svg";
export { ForwardRef as ReactComponent };